export function formatNumber(text, isDecimal = true) {
  if (!text) {
    return ''
  }
  if (text.length === 0) {
    return ''
  }
  if (!isDecimal) {
    return text
  }

  const truncatedNumber = Number.parseFloat(Number.parseFloat(text).toFixed(2))
  if (('' + truncatedNumber).split('.').length === 2) {
    return ('' + truncatedNumber).split('.')[0]
  }
  return truncatedNumber
}



// WEBPACK FOOTER //
// ./src/components/questions/formatNumber.js